import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex min-h-[70vh] w-full flex-col items-center justify-center px-4 text-center">
      <h1 className="pointer-events-none absolute select-none font-heading text-[7rem] font-black text-primary-100 md:text-[11rem]">
        404
      </h1>
      <div className="relative z-10 flex flex-col items-center">
        <span className="flex h-16 w-16 items-center justify-center rounded-full bg-primary-100 text-primary-600">
          <i className="ri-ghost-smile-line text-3xl"></i>
        </span>
        <h2 className="mt-5 font-heading text-2xl font-bold text-foreground-950">页面走丢了</h2>
        <p className="mt-2 text-sm text-foreground-500">
          没有找到你要访问的页面：<span className="font-mono text-foreground-700">{location.pathname}</span>
        </p>
        <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            className="whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 hover:bg-primary-600"
          >
            返回首页
          </Link>
          <Link
            to="/category/movie"
            className="whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-2.5 text-sm font-medium text-foreground-700 hover:border-primary-300 hover:text-primary-600"
          >
            去逛逛电影
          </Link>
        </div>
      </div>
    </div>
  );
}